import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

import orthocareetimage from "../../../images/remattressorientation/ortho care  ET.png";

export default function OrthobondPage() {
  const categoryName = "Orthobond";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
      name: "POSTURE CARE",
      link: "/luxury-collection/posture-care/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-visco_PNG.png",
      name: "ORTHO VISCO LX",
      link: "/luxury-collection/ortho-visco-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover-1.png",
      name: "ORTHO LATEX LX",
      link: "/luxury-collection/ortho-latex-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-visco.png",
      name: "ORTHO VISCO",
      link: "/visco-mattress/ortho-visco/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-Latex.png",
      name: "ORTHO LATEX",
      link: "/latex-mattress/ortho-latex/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-care-PNG.png",
      name: "ORTHO CARE LX",
      link: "/serene-series/ortho-care-lx/",
    },
    {
      img: orthocareetimage,
      name: "ORTHO CARE ET",
      link: "/ortho-mattress/ortho-care-et/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-care.png",
      name: "ORTHO CARE",
      link: "/ortho-mattress/ortho-care/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Orthospine_1000X667.png",
      name: "ORTHOSPINE",
      link: "/ortho-mattress/orthospine/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-3.png",
      name: "ORTHOTONIC",
      link: "/ortho-mattress/orthotonic/",
    },
  ];

  const categoryDescription =
    "Explore standalone and hybrid mattresses that use high density Orthobond Foam to deliver high back support and superior comfort. Great for those looking for pain relief and excellent durability.";

  return (
    <div>
      <SEO
        title="Orthobond Mattress | Eclipse International"
        description="Discover our range of the finest orthobond mattresses with best in class breathable fabric and pressure relieving materials."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
